// Adapter para la API de KPIs de pedidos
// Orders KPIs API adapter

import { apiClientWH } from '@shared/services/ApiClient';

export interface OrdersKpisData {
  sent: number;
  pending: number;
  preparing: number;
  to_confirm: number;
  percentage_sent: number;
}

export interface OrdersKpisResponse {
  success: boolean;
  data: OrdersKpisData;
  message: string;
}

export interface OrdersKpisParams {
  date?: string; // Y-m-d format
  cutoff_time?: string; // H:i format
  shop_id?: number;
}

export class OrdersKpisApiAdapter {
  constructor(private httpClient: typeof apiClientWH) {}

  /**
   * GET /report/orders-kpis
   * Parámetros:
   * - date (opcional): Date to filter orders (Y-m-d format). Defaults to today
   * - cutoff_time (opcional): Cutoff time for pending orders (H:i format). Defaults to 14:00
   * - shop_id (opcional): Shop ID to filter orders. Optional
   */
  async getOrdersKpis(params: OrdersKpisParams = {}): Promise<OrdersKpisResponse> {
    const response = await this.httpClient.get('/report/orders-kpis', {
      params: {
        date: params.date,
        cutoff_time: params.cutoff_time || '14:00',
        shop_id: params.shop_id,
      },
    });

    return response.data;
  }
}
